export default __webpack_public_path__ + "static/hero-ai-mobile-7f513c2774872445c1bfae496dbfd262.webp";